import { abstract as viemAbstract } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const abstract = {
  displayName: 'Abstract',
  runtime: 'evm',
  viemChain: viemAbstract,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'abstract' },
    qnStreams: {
      networkKey: 'abstract-mainnet',
    },
  }),
} as const satisfies AllChainConfig<'evm', false>;
